/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeoJsonCountyDataModelApiModel } from '../../models/geo-json-county-data-model-api-model';

export interface GetAllBoundries$Params {
}

export function getAllBoundries(http: HttpClient, rootUrl: string, params?: GetAllBoundries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeoJsonCountyDataModelApiModel>>> {
  const rb = new RequestBuilder(rootUrl, getAllBoundries.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeoJsonCountyDataModelApiModel>>;
    })
  );
}

getAllBoundries.PATH = '/v1/counties/boundries';
